import React, { FC } from 'react'

import { ContentfulProcessor } from '@smarty-nx/ds'

export const Tile: FC<Queries.GenericBannerFragment> = ({
  link,
  description,
  title,
  image,
}) => {
  const href = link?.internal.content
  const alt = description?.internal.content || image?.description || title
  const imageUrl = image?.url || ''
  const src = imageUrl ? `${imageUrl}?w=300` : ''

  if (!href) {
    return (
      <img alt={alt} title={alt} src={src} loading="lazy" decoding="async" />
    )
  }

  return (
    <ContentfulProcessor
      content={href}
      components={{
        a({ node: _, ...props }) {
          return (
            <a {...props}>
              <img
                alt={alt}
                title={alt}
                src={src}
                loading="lazy"
                decoding="async"
              />
            </a>
          )
        },
      }}
    />
  )
}
